import { render, staticRenderFns } from "./regNPayForm.vue?vue&type=template&id=713b0b39&"
import script from "./regNPayForm.vue?vue&type=script&lang=ts&scoped=true&"
export * from "./regNPayForm.vue?vue&type=script&lang=ts&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports